import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css'
import './reset.css'
import './main.less'
import './swiper-bundle.min.css';
import App from './App.vue';
import less from 'less'
import router from '@/router/router.js'
/*import echarts from "echarts";*/
import VueClipboard from 'vue-clipboard2'
import qs from 'qs'
import md5 from 'js-md5'
import axios from 'axios';
/*import AxiosPlugin from 'vue-axios-cors';*/
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFloala from 'vue-froala-wysiwyg';
import VueAliplayerV2 from 'vue-aliplayer-v2';
import VueLoaders from 'vue-loaders';
import 'font-awesome/css/font-awesome.min.css';

Vue.use(VueAliplayerV2,{
    cssLink: 'https://g.alicdn.com/de/prismplayer/2.13.2/skins/default/aliplayer-min.css',
    scriptSrc: 'https://g.alicdn.com/de/prismplayer/2.13.2/aliplayer-min.js'
});
axios.defaults.withCredentials=true;

Vue.use(VueClipboard);
Vue.use(VueFloala);
Vue.use(VueLoaders);
/*Vue.use(AxiosPlugin);*/
/*Vue.prototype.$echarts = echarts;*/
Vue.prototype.$qs = qs;
Vue.prototype.$md5 = md5;
Vue.prototype.$axios = axios;
Vue.use(less);
Vue.use(ElementUI);
// Vue.use(ElementPlus);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');